export default "__VITE_ASSET__084793e5__"